var render = function render(){var _vm=this,_c=_vm._self._c;return _c('drop-zone',{directives:[{name:"show",rawName:"v-show",value:(_vm.isVisible),expression:"isVisible"}],staticClass:"field-drop",attrs:{"handle":"field-container","target-selector":_vm.targets},on:{"drop":function($event){return _vm.$emit('drop', $event)}}},[_c('v-icon',{attrs:{"name":"plus-circle"}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }